module.exports = __webpack_public_path__ + "static/media/insta3.88445a15.jpg";